export const enum RoleType {
    basic = "basic",
    shiftleader = "shift_leader",
    manager = "manager"
}


// WEBPACK FOOTER //
// ./src/Models/Users/RoleType.tsx